import classNames from 'classnames';
import styles from './Tooltip.module.scss';
import React from 'react';

interface Props {
  text: string;
  position?: 'top' | 'bottom';
  className?: string;
}

const TooltipBody = ({ text, position = 'top', className }: Props) => (
  <div
    className={classNames(
      position === 'top' ? styles.topTooltip : styles.bottomTooltip,
      className,
      styles.darkTheme,
    )}
  >
    {text}
  </div>
);

export default TooltipBody;
